import { useServicesChartsDataContext } from '../../../hooks/useServicesChartsDataContext';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Util/getMonthsByYear';
import { useMemo } from 'react';

const useServicesPerMonthPerYearTotalChart = () => {
    const { subtitles, chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = useMemo(
        () =>
            subtitles.map((item) => {
                const data = months.map((month) => {
                    const found = chartData.selectedYear.find(
                        (counter) =>
                            (counter.description ?? '-') === item &&
                            parseInt(counter.mes_competencia, 10) ===
                                monthsIndexes[month]
                    );

                    return found ? Number(found.services) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData, subtitles, months]
    );

    return {
        series,
        months
    };
};

export default useServicesPerMonthPerYearTotalChart;
